import * as React from 'react';
import { Modal, ModalFooter } from '@grandvisionhq/common';
import { Util } from '@grandvisionhq/forms';
import { useDispatch, useSelector } from '@grandvisionhq/state';
import { useBaseSummarySlot } from '../../slots/summaries/summary-context.js';
import { updateShippingDetails } from '../../StepShipping/actions.js';
import 'motion/react';
import '../../slots/forms/form-context.js';
import '../../slots/summaries/types.js';
import { getShippingData } from '../../StepShipping/selectors.js';
import { ContactDetailsContainer } from '../../StepShipping/containers/ContactDetailsContainer.js';
import '@grandvisionhq/elements';
import '../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import '@grandvisionhq/icons';

const EditableContactDetailsSummary = ({ labels  })=>{
    var ref, ref1;
    const [ContactDetailsFormData, setContactDetailsFormData] = React.useState();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const { Slots  } = useBaseSummarySlot();
    const dispatch = useDispatch();
    const contactDetailsData = (ref = useSelector(getShippingData)) === null || ref === void 0 ? void 0 : ref.contactDetails;
    const hasData = contactDetailsData && !Object.values(contactDetailsData).every((x)=>x === null || x === ''
    );
    const ContactDetailsSummarySlot = Slots.contactDetails;
    if (!ContactDetailsSummarySlot && hasData) {
        console.error('This opco is misconfigured. It has contact details data, but no contact details summary card setup.');
    }
    if (!ContactDetailsSummarySlot || !hasData) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isModalOpen,
        onModalClose: ()=>setIsModalOpen(false)
        ,
        showIcon: true,
        footer: /*#__PURE__*/ React.createElement(ModalFooter, {
            ctaCaption: labels === null || labels === void 0 ? void 0 : (ref1 = labels.editModal) === null || ref1 === void 0 ? void 0 : ref1.save,
            onCta: ()=>{
                if (!(ContactDetailsFormData === null || ContactDetailsFormData === void 0 ? void 0 : ContactDetailsFormData.formValid)) {
                    Util.focusToTopErrorFieldOnScreen();
                } else {
                    ContactDetailsFormData && dispatch(updateShippingDetails({
                        form: ContactDetailsFormData
                    }));
                    setIsModalOpen(false);
                }
            },
            onCancel: ()=>setIsModalOpen(false)
        })
    }, /*#__PURE__*/ React.createElement(ContactDetailsContainer, {
        onChange: (formData)=>setContactDetailsFormData(formData)
    })), hasData && /*#__PURE__*/ React.createElement(ContactDetailsSummarySlot, {
        actions: {
            onEdit: ()=>setIsModalOpen(true)
        },
        values: contactDetailsData
    }));
};

export { EditableContactDetailsSummary, EditableContactDetailsSummary as default };
//# sourceMappingURL=EditableContactDetailsSummary.js.map
